import MileageListResponse, {
  MileageListResponseAddressSequence,
  MileageListResponseAddressSequenceNode,
  MileageListResponseItem,
  MileageListResponseState,
  MileageListResponseVehicleType,
} from "../../../api/raily/mileage/list/mileage-list.response";
import MileageStatus from "../../../types/mileage-status";
import VehicleType from "../../../types/vehicle-type";
import MileageList, {
  MileageListAddressSequence,
  MileageListAddressSequenceNode,
  MileageListItem,
} from "./mileage-list";

const createAddressSequenceNode = (
  node: MileageListResponseAddressSequenceNode,
): MileageListAddressSequenceNode => {
  return {
    displayName: node.displayName,
    lat: node.lat,
    lon: node.lon,
  };
};

const createAddressSequence = (
  responseSequence: MileageListResponseAddressSequence,
): MileageListAddressSequence => {
  const sequence: MileageListAddressSequenceNode[] = responseSequence.seq.map(
    createAddressSequenceNode,
  );

  return {
    seq: sequence,
  };
};

const createStatus = (state: MileageListResponseState): MileageStatus => {
  switch (state) {
    case MileageListResponseState.ACCEPTED:
      return MileageStatus.ACCEPTED;
    case MileageListResponseState.DELEGATION_CREATED:
      return MileageStatus.DELEGATION_CREATED;
    case MileageListResponseState.PENDING:
      return MileageStatus.PENDING;
    case MileageListResponseState.REJECTED:
      return MileageStatus.REJECTED;
  }
};

const createVehicleType = (
  type: MileageListResponseVehicleType,
): VehicleType => {
  switch (type) {
    case MileageListResponseVehicleType.CAR_GT_900CM3:
      return VehicleType.CAR_GT_900CM3;
    case MileageListResponseVehicleType.CAR_LE_900CM3:
      return VehicleType.CAR_LE_900CM3;
    case MileageListResponseVehicleType.COMPANY_OWNED:
      return VehicleType.COMPANY_OWNED;
    case MileageListResponseVehicleType.MOPED:
      return VehicleType.MOPED;
    case MileageListResponseVehicleType.MOTORCYCLE:
      return VehicleType.MOTORCYCLE;
  }
};

const createDataItem = (item: MileageListResponseItem): MileageListItem => {
  return {
    addressSeq: createAddressSequence(item.addressSeq),
    distance: item.distance,
    humanId: item.humanId,
    uuid: item.id,
    mileageDate: item.mileageDate,
    status: createStatus(item.state),
    vehicleType: createVehicleType(item.vehicleType),
    workerCompanyUuid: item.workerCompanyId,
    workerUuid: item.workerId,
    workerName: item.workerName,
    workerPhone: item.workerPhone,
    cardNumber: item.cardNumber,
    cargoCompanyName: item.cargoCompanyName,
    mileageNumber: item.mileageNumber,
    osrmDistance: item.osrmDistance,
    acceptedDistance: item.acceptedDistance,
  };
};

const createData = (
  responseData: MileageListResponseItem[],
): MileageListItem[] => {
  const items: MileageListItem[] = responseData.map(createDataItem);

  return items;
};

const create = (response: MileageListResponse): MileageList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const mileageListFactory = {
  create,
};

export default mileageListFactory;
